<template>
    <div id="article">
        <Header></Header>
        <loader @onLoadingComplete="onLoadingComplete"></loader>
        <article-page v-show="!loading" :data="article"></article-page>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/common/Header'
    import Footer from '../components/common/Footer'
    import ArticlePage from '../components/pages/ArticlePage'
    import Loader from '../components/common/Loader'
    import {mapGetters} from 'vuex'

    export default {
        name: 'Article',
        props: ['shortname'],
        data() {
            return {
                loading: true,
                article: {},
            }
        },
        components: {
            Header,
            ArticlePage,
            Footer,
            Loader
        },
        computed: {
            ...mapGetters([
                'getArticle',
            ])
        },
        methods: {
            onLoadingComplete(stat) {
                this.loading = stat;
            }
        },
        mounted() {
            this.$store.dispatch('getArticle', this.shortname).then((response) => {
                this.article = response.article;
            });
            this.$store.dispatch('getRecentPosts', 'hirek');
            this.$store.dispatch('getMostPopularPosts', 'hirek');
        },
        watch: {
            getArticle: function(newVal) {
                this.article = newVal;
            }
        }
    }
</script>